import {ExperimentalRole} from 'samples/experimental-roles/ExperimentalRoleConstants';
import * as TaskRunner from 'util/TaskRunner';

// Keep up to date with /src/benchling/inventory/plate_map/ai_assistant/ai_assistant/role_annotation_inference_engine.py
// (swapped from snake to camel case).
interface SuccessfulInferAnnotationParamsResponse {
  roleAnnotations: {[coordinate: string]: ExperimentalRole};
  traceId: string;
  error: null;
}
interface FailedInferAnnotationParamsResponse {
  roleAnnotations: null;
  traceId: string;
  error: string;
}
export type InferAnnotationParamsResponse =
  | SuccessfulInferAnnotationParamsResponse
  | FailedInferAnnotationParamsResponse;

export async function inferAnnotationParamsWithAi({
  userPrompt,
  dimensions,
  currentRoles,
}: {
  userPrompt: string;
  dimensions: {rows: number; columns: number};
  currentRoles: {[coord: string]: ExperimentalRole};
}): Promise<InferAnnotationParamsResponse> {
  const inferredParamsResp = await TaskRunner.postJSONPromise({
    url: '/1/api/grids/ai-assistant:suggest-role-annotations',
    data: {
      userPrompt,
      dimensions,
      currentRoles,
    },
  });
  return inferredParamsResp;
}
